<fgb-account-layout titleKey="account.facial-recognition.title" titleDefault="Facial Recognition">
  <fgb-account-panel titleKey="account.facial-recognition.title" titleDefault="Facial Recognition">
    <fgb-facial-recognition-entry></fgb-facial-recognition-entry>
  </fgb-account-panel>
</fgb-account-layout>
